var _this_1 = this;
import { Dimensions, NativeModules } from "react-native";
var AccessibilityManager = NativeModules.AccessibilityManager;
var _a = Dimensions.get('window'),
  height = _a.height,
  width = _a.width;
var fontSizeMultipliers = {
  extraSmall: 0.94,
  small: 0.96,
  medium: 0.98,
  large: 1,
  extraLarge: 1.025,
  extraExtraLarge: 1.05,
  extraExtraExtraLarge: 1.075,
  accessibilityMedium: 1.1,
  accessibilityLarge: 1.15,
  accessibilityExtraLarge: 1.2,
  accessibilityExtraExtraLarge: 1.25,
  accessibilityExtraExtraExtraLarge: 1.3
};
var _globalStyles = {
  width: width,
  height: height,
  setAccessibilityMultiplier: function () {
    // ios only
    if (!(AccessibilityManager && AccessibilityManager.getMultiplier)) return;
    var _this = _this_1;
    AccessibilityManager.getMultiplier(function (i) {
      _this.accessibilityMultiplier = i;
    });
  },
  accessibilityMultiplier: 1,
  setAccessibilityMultipliers: function () {
    // ios only
    if (!(AccessibilityManager && AccessibilityManager.setAccessibilityContentSizeMultipliers)) return;
    AccessibilityManager.setAccessibilityContentSizeMultipliers(fontSizeMultipliers);
  },
  marginHorizontal: width < 375 ? 10 : 15
};
_globalStyles.setAccessibilityMultipliers();
_globalStyles.setAccessibilityMultiplier();
export var colors = {
  backgroundGray: '#EFEFF4',
  buttonActive: '#E5E5EA',
  white: '#ffffff',
  // offWhite: '#F5F5F7',
  whiteShade: '#E9E9E9',
  lighterGray: '#DDDDDD',
  lightGray: '#CCCCCC',
  gray: '#6B6B6B',
  darkGray: '#333333',
  darkerGray: '#1B1B1B',
  black: '#000000',
  red: '#D1231D',
  yellow: '#F1C400',
  blue: '#003087',
  blueHighlight: '#3B579D',
  darkBlue: '#01175B',
  cyan: '#147499',
  darkCyan: '#18759A',
  darkerCyan: '#006B95',
  cyanActive: '#18789C',
  green: '#14892C',
  switchON: '#147499',
  transparentBlack: 'rgba(0, 0, 0, 0.3)',
  transparentBlackHighlight: 'rgba(50, 50, 50, 0.5)',
  transparentWhite: 'rgba(255, 255, 255, .85)',
  shadow: function (width, height, shadowRadius, shadowColor, shadowOpacity) {
    return {
      shadowColor: shadowColor,
      shadowOffset: {
        width: width,
        height: height
      },
      shadowRadius: shadowRadius,
      shadowOpacity: shadowOpacity
    };
  }
};
export var globalStyles = _globalStyles;
export default colors;